import React from "react";
import style from "../styles/footer.module.css";
import { AiFillGithub, AiFillLinkedin, AiOutlineMail } from "react-icons/ai";
import { profile } from "../data/profile";

const Footer = () => (
  <footer className={style.footer}>
    <div className={style.inner}>
      <p className={style.name}>
        <span className={style.brandMark}>A</span>kil Sadik M H
      </p>
      <p className={style.role}>{profile.role}</p>
      <div className={style.links}>
        <a href={profile.githubUrl} target="_blank" rel="noreferrer" aria-label="GitHub">
          <AiFillGithub />
        </a>
        <a href={profile.linkedinUrl} target="_blank" rel="noreferrer" aria-label="LinkedIn">
          <AiFillLinkedin />
        </a>
        <a href={`mailto:${profile.email}`} aria-label="Email">
          <AiOutlineMail />
        </a>
      </div>
      <p className={style.built}>
        Built with React &amp; Framer Motion<span className={style.dot} />
        <a href="#home">Back to top</a>
      </p>
    </div>
  </footer>
);

export default Footer;
